
























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { MachineOverview, MachineDetail } from '../store/machine'
import Add from './Add.vue'
import Detail from './Detail.vue'
const machine = namespace('machine')
const sensors = namespace('sensor')
const alarms = namespace('alarm')
const warnings = namespace('warning')
const company = namespace('company')
@Component({ components: { Add, Detail } })
export default class MachineView extends Vue {
  @machine.Getter machines!: MachineOverview[]
  @machine.Action getAll!: () => void
  @machine.Action get!: (id: number) => MachineDetail
  @sensors.Action('loadSensors') loadSensors!: () => Promise<void>
  @alarms.Action('getAll') loadAlarms!: () => Promise<void>
  @warnings.Action('getAll') loadWarnings!: () => Promise<void>
  @company.Action('loadCompanies') loadCompanies!: () => Promise<void>
  machine: MachineDetail | null = null
  dialog = false

  created() {
    this.getAll()
    this.loadSensors()
    this.loadWarnings()
    this.loadAlarms()
    this.loadWarnings()
    this.loadCompanies()
  }

  async select(id: number) {
    this.machine = await this.get(id)
    this.dialog = true
  }
}
